module.exports = __webpack_public_path__ + "img/nrc.a483bb31.png";